import { createSlice } from '@reduxjs/toolkit';
import { refreshFast, refreshSlow, refreshDaily } from './AppStore';

export const reducerName = 'authState';

const orgId = localStorage.getItem('orgId');
const apiKey = localStorage.getItem('apiKey');

const initialState = {
    orgId: orgId || null,
    apiKey: apiKey || null,
};

const authSlice = createSlice({
    name: reducerName,
    initialState,
    reducers: {
        setOrgId: (state, action) => {
            localStorage.setItem('orgId', action.payload);
            state.orgId = action.payload;
        },
        setApiKey: (state, action) => {
            localStorage.setItem('apiKey', action.payload);
            state.apiKey = action.payload;
        },
    },
});

export const { setOrgId, setApiKey } = authSlice.actions;

export const login = () => (dispatch) => {
    dispatch(refreshFast());
    dispatch(refreshSlow());
    dispatch(refreshDaily());
};

export default authSlice.reducer;